<template>
  <div class="requirements dbox">
    <TextField2
      :id="'default_single_rooms'"
      :label="$dft.capHead($t('single_rooms'))"
      :value="selectedArtist.default_single_rooms"
      :placeholder="$t('single_rooms')"
      @change="onTextFieldValueChange"
    />
    <TextField2
      :id="'default_double_rooms'"
      :label="$dft.capHead($t('double_rooms'))"
      :value="selectedArtist.default_double_rooms"
      :placeholder="$t('double_rooms')"
      @change="onTextFieldValueChange"
    />
    <TextField2
      :id="'default_suites'"
      :label="$dft.capHead($t('suites'))"
      :value="selectedArtist.default_suites"
      :placeholder="$t('suites')"
      @change="onTextFieldValueChange"
    />
    <TextField2
      :id="'default_hotel_stars'"
      :label="$dft.capHead($t('hotel_class'))"
      :value="selectedArtist.default_hotel_stars"
      :placeholder="$t('hotel_class')"
      @change="onTextFieldValueChange"
      bb="none"
    />
  </div>
</template>

<script>

export default {
  props: {
    selectedArtist: {
      type: Object,
      required: true,
    },
  },
  data: function () {
    return {
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: false,
      },      
    };
  },
  methods: {
    onTextFieldValueChange: function ({ name, value }) {
      this.$emit("changed", { name, value });
    },
    // Mark: Methods
  },
};
</script>

<style lang="scss" scoped>
// .dt-input-box--container {
//   margin: 5px;
// }
</style>
